import * as THREE from 'three';


export class CurveEditor {
    constructor(canvas, controlPoints, xMirror) {
        this.canvas = canvas;
        this.BOX_SIZE = 15;
        this.scale = 0.7; // 缩放，最好是动态决定
        // console.log("curve editor scale is", this.scale);
        this.context = canvas.getContext("2d");
        this.xMirror = xMirror === undefined ? false : xMirror;

        this.controlPointsOrigin = controlPoints || [
            // new THREE.Vector2(0, -200),
            // new THREE.Vector2(36, -150),
            // new THREE.Vector2(-8, 0),
            // new THREE.Vector2(-50, 150),
            // new THREE.Vector2(0, 200)
            new THREE.Vector2(24, -143.7763310185185),
            new THREE.Vector2(-29.60026041666667, -72.33224826388889),
            new THREE.Vector2(-52.31105324074074, 4),
            new THREE.Vector2(-47.444082754629626, 93.33224826388889),
            new THREE.Vector2(28, 137.7763310185185)
        ];
        this.controlPoints = this.controlPointsOrigin.map(p => p.clone().multiplyScalar(this.scale));

        this.mouse_pos = new THREE.Vector2(); // 鼠标当前位置
        this.mouse_hit_index = -1; // 鼠标落在哪个控制点上

        this.start_drag_pos = new THREE.Vector2(); // 鼠标拖动时的初始位置
        this.drag_target_index = -1; // 鼠标拖动的对象
        this.drag_target_start_pos = new THREE.Vector2(); // 拖动对象的初始位置
        this.drag_vector = new THREE.Vector2(); // 拖动矢量

        const editor = this;
        this.canvas.addEventListener("touchstart", function (e) {
            e.stopPropagation();
            e.preventDefault();
            let bound = canvas.getBoundingClientRect();
            let x = e.changedTouches[0].clientX - bound.left;
            let y = e.changedTouches[0].clientY - bound.top;
            editor.mouse_pos.x = x - bound.width / 2;
            editor.mouse_pos.y = y - bound.height / 2;

            // console.log(x,y);
            editor.hitTest();

            if (editor.mouse_hit_index >= 0) {
                editor.startDrag();
            }
            editor.draw();
        });
        this.canvas.addEventListener("touchmove", function (e) {
            e.stopPropagation();
            e.preventDefault();
            // console.log("touchmove");
            let bound = canvas.getBoundingClientRect();
            let x = e.changedTouches[0].clientX - bound.left;
            let y = e.changedTouches[0].clientY - bound.top;
            editor.mouse_pos.x = x - bound.width / 2;
            editor.mouse_pos.y = y - bound.height / 2;

            editor.error = false;
            // console.log(editor.onCurveChange);
            if (editor.drag_target_index >= 0) {
                editor.doDrag();
                try {
                    if (editor.onCurveChange) {
                        editor.onCurveChange();
                    }
                } catch (e) {
                    editor.error = true;
                    // console.error(e);
                }
                editor.draw();
            }

        });
        this.canvas.addEventListener("touchend", function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (editor.drag_target_index >= 0) {
                editor.endDrag();
            }
            editor.draw();
            setTimeout(() => {
                this.showLoading = false;
            }, 50);
        });

        this.draw();
    }

    setSize() {
        if (this.sizeSetted) return;

        this.sizeSetted = true;
        let parentNode = this.canvas.parentNode;
        let bound = parentNode.getBoundingClientRect();
        let width = Math.floor(bound.width);
        let height = Math.floor(bound.height);
        this.canvas.style.width = width + "px";
        this.canvas.style.height = height + "px";
        this.canvas.width = width;
        this.canvas.height = height;

        this.width = this.canvas.width;
        this.height = this.canvas.height;
        this.centerX = Math.round(this.width / 2);
        this.centerY = Math.round(this.height / 2);

        let maxX = Math.abs(this.controlPointsOrigin[0].x);
        let maxY = Math.abs(this.controlPointsOrigin[0].y);
        for (let i = 1; i < this.controlPointsOrigin.length; i++) {
            maxX = Math.max(maxX, Math.abs(this.controlPointsOrigin[i].x));
            maxY = Math.max(maxY, Math.abs(this.controlPointsOrigin[i].y));
        }

        maxX += 20;
        maxY += 20;

        let halfWidth = bound.width / 2;
        let halfHeight = bound.height / 2;
        let scale1 = halfWidth / maxX;
        let scale2 = halfHeight / maxY;
        this.scale = Math.min(scale1, scale2);
        // console.log("update size", this.scale);

        this.controlPoints = this.controlPointsOrigin.map(p => p.clone().multiplyScalar(this.scale));

        this.min_x = -this.centerX + 10;
        this.min_y = -this.centerY + 10;
        this.max_y = this.centerY - 10;
    }

    loadSize(scale, width, height) {
        if (this.sizeSetted) return;
        this.sizeSetted = true;
        this.canvas.style.width = width + "px";
        this.canvas.style.height = height + "px";
        this.canvas.width = width;
        this.canvas.height = height;

        this.width = this.canvas.width;
        this.height = this.canvas.height;
        this.centerX = Math.round(this.width / 2);
        this.centerY = Math.round(this.height / 2);

        this.scale = scale;
        // console.log("curve editor scale is", this.scale);

        this.min_x = -this.centerX + 10;
        this.min_y = -this.centerY + 10;
        this.max_y = this.centerY - 10;
    }

    onCurveChanged(handler) {
        this.onCurveChange = handler;
    }

    setOnCurveChangeDown(handler) {
        this.onCurveChangeDown = handler;
    }

    onError(handler) {
        this.onErrorHandler = handler
    }

    getCurve() {
        return new THREE.SplineCurve(this.controlPoints.map(p => p.clone().divideScalar(this.scale)));
    }

    getControlPoints() {
        return this.controlPoints.map(p => p.clone().divideScalar(this.scale));
    }

    startDrag() {
        this.drag_target_index = this.mouse_hit_index;
        this.start_drag_pos.copy(this.mouse_pos);
        this.drag_target_start_pos.copy(this.controlPoints[this.drag_target_index]);
    }

    doDrag() {
        this.drag_vector.subVectors(this.mouse_pos, this.start_drag_pos);
        this.controlPoints[this.drag_target_index].addVectors(this.drag_target_start_pos, this.drag_vector);
        if (this.xMirror) {
            this.controlPoints[this.drag_target_index].x = THREE.Math.clamp(this.controlPoints[this.drag_target_index].x, this.min_x, -this.min_x);
            this.controlPoints[this.drag_target_index].y = THREE.Math.clamp(this.controlPoints[this.drag_target_index].y, this.min_y, this.max_y);
            let centerIndex = (this.controlPoints.length - 1) / 2;
            if (this.drag_target_index == centerIndex) {
                this.controlPoints[this.drag_target_index].y = 0;
            } else {
                let y = this.controlPoints[this.drag_target_index].y;
                if (this.drag_target_index > centerIndex) {
                    y = Math.max(y, 5);
                } else {
                    y = Math.min(y, -5);
                }
                this.controlPoints[this.drag_target_index].y = y;
                this.controlPoints[this.controlPoints.length - this.drag_target_index - 1].set(
                    this.controlPoints[this.drag_target_index].x,
                    -y
                );
            }
        } else {
            this.controlPoints[this.drag_target_index].x = THREE.Math.clamp(this.controlPoints[this.drag_target_index].x, this.min_x, (60 - 4) * this.scale);
            this.controlPoints[this.drag_target_index].y = THREE.Math.clamp(this.controlPoints[this.drag_target_index].y, this.min_y, this.max_y);
        }
    }

    endDrag() {
        this.mouse_hit_index = -1;
        this.drag_target_index = -1;
        let str = this.controlPoints.map(p => "new THREE.Vector2(" + p.x + ", " + p.y + ")").join(", ");
        // console.log(str);
        if (this.onCurveChangeDown) { this.onCurveChangeDown(); }
    }

    // 鼠标击中测试
    hitTest() {
        let center = this.mouse_pos;
        let radius = this.BOX_SIZE;
        this.mouse_hit_index = this.controlPoints.findIndex(p => p.distanceTo(center) <= radius);
    }

    draw() {
        this.clear();
        this.drawMesh();
        if (!this.xMirror) {
            this.drawCutLine();
        }
        this.drawControlPoints();
        this.drawCurve();
    }

    clear() {
        this.context.clearRect(-1, -1, this.canvas.width + 1, this.canvas.height + 1);
    }

    drawMesh() {
        const cubeSize = (this.xMirror ? 5 : 30) * this.scale;
        let width = this.canvas.width;
        let height = this.canvas.height;
        let centerX = Math.round(width / 2);
        let centerY = Math.round(height / 2);
        this.context.beginPath();
        // let x = centerX - cubeSize;
        let x = centerX;
        while (x > 0) {
            this.context.moveTo(x, 0);
            this.context.lineTo(x, height);
            x -= cubeSize;
        }
        x = centerX + cubeSize;
        while (x < width) {
            this.context.moveTo(x, 0);
            this.context.lineTo(x, height);
            x += cubeSize;
        }
        // let y = centerY - cubeSize;
        let y = centerY;
        while (y > 0) {
            this.context.moveTo(0, y);
            this.context.lineTo(width, y);
            y -= cubeSize;
        }
        y = centerY + cubeSize;
        while (y < height) {
            this.context.moveTo(0, y);
            this.context.lineTo(width, y);
            y += cubeSize;
        }
        this.context.closePath();
        this.context.lineWidth = 1;
        this.context.strokeStyle = "#ccc";
        this.context.stroke();
    }

    drawCutLine() {
        let height = this.height;
        let centerX = this.centerX;
        let x = centerX + 60 * this.scale;

        this.context.beginPath();
        this.context.moveTo(x, 0);
        this.context.lineTo(x, height);
        this.context.closePath();
        this.context.lineWidth = 2;
        this.context.strokeStyle = "#ff0000";
        this.context.stroke();
    }

    drawControlPoints() {
        const boxSize = this.BOX_SIZE;
        let width = this.canvas.width;
        let height = this.canvas.height;
        let centerX = Math.round(width / 2);
        let centerY = Math.round(height / 2);
        this.context.fillStyle = "#05A8F3";

        for (let i = 0; i < this.controlPoints.length; i++) {
            if (i !== this.mouse_hit_index) {
                let p = this.controlPoints[i];
                this.context.beginPath();
                this.context.arc(centerX + p.x, centerY + p.y, boxSize, 0, 2 * Math.PI);
                this.context.closePath();
                this.context.fillStyle = "#05A8F3";
                this.context.shadowBlur = 25;
                this.context.shadowColor = "rgba(155, 204, 253, 1)"; // 阴影颜色
                this.context.shadowBlur = 7.5; // 阴影模糊范围
                this.context.fill();
                // this.context.fillRect(centerX + p.x - boxSizeHalf, centerY + p.y - boxSizeHalf, boxSize, boxSize);
            }
        }

        this.context.shadowColor = "rgba(100, 100, 100, 0)";


        if (this.mouse_hit_index >= 0) {
            let p = this.controlPoints[this.mouse_hit_index];
            this.context.lineWidth = 1;

            this.context.strokeStyle = "#FFF";
            this.context.beginPath();
            this.context.arc(centerX + p.x, centerY + p.y, boxSize + 5, 0, 2 * Math.PI);
            this.context.closePath();
            this.context.fillStyle = "#FFF";
            this.context.shadowBlur = 25;
            this.context.shadowColor = "rgba(229, 229, 229, 1)";
            this.context.shadowBlur = 7.5; // 阴影模糊范围
            this.context.fill();
            this.context.shadowColor = "rgba(100, 100, 100, 0)";

            this.context.strokeStyle = "#04A9F3";
            this.context.beginPath();
            this.context.arc(centerX + p.x, centerY + p.y, boxSize, 0, 2 * Math.PI);
            this.context.closePath();
            this.context.fillStyle = "#04A9F3";
            this.context.fill();
        }
    }


    drawCurve() {
        let curve = new THREE.SplineCurve(this.controlPoints);
        let points = curve.getPoints(50);
        let width = this.canvas.width;
        let height = this.canvas.height;
        let centerX = Math.round(width / 2);
        let centerY = Math.round(height / 2);
        this.context.strokeStyle = "#2F3B4B";
        this.context.lineWidth = 5;
        this.context.beginPath();
        this.context.moveTo(points[0].x + centerX, points[0].y + centerY);
        for (let i = 1; i < points.length; i++) {
            this.context.lineTo(points[i].x + centerX, points[i].y + centerY);
        }
        this.context.lineCap = 'round';
        this.context.stroke();
        this.context.closePath();
    }

    incControlPoint() {
        let curve = this.getCurve();
        let cnt = this.controlPoints.length;
        let newPoints = curve.getPoints(cnt);
        // console.log("newPoints", newPoints);
        this.setVaseContent(newPoints);
    }

    redControlPoint() {        
        let curve = this.getCurve();
        let cnt = (this.controlPoints.length - 1) * 2 - 2;
        let newPoints = curve.getPoints(cnt);
        let newPoints2 = [];
        for (let i = 0; i < newPoints.length; i += 2) {
            newPoints2.push(newPoints[i]);
        }
        // console.log("newPoints2", newPoints2);
        this.setVaseContent(newPoints2);
    }

    setVaseContent(controlPoints) {
        this.controlPointsOrigin = controlPoints;
        this.controlPoints = this.controlPointsOrigin.map(p => p.clone().multiplyScalar(this.scale));
        this.draw();
    }

    getVaseContent() {
        return this.controlPoints.map(p => p.clone().divideScalar(this.scale));
    }
}


// WEBPACK FOOTER //
// ./src/views/reliefVase/scripts/CurveEditor.js